import { Switch, Route, Redirect } from 'react-router-dom';
import { useUserAuth } from '../state/userAuthContext';
import { opsSupportRoutes } from './allRoutes';

const switchRoutes = (
  <Switch>
    {opsSupportRoutes.map((prop, key) => {
      if (prop.layout === 'ops-support') {
        return <Route path={`/${prop.layout}${prop.path}`} component={prop.component} key={key} exact />;
      }
      return null;
    })}
    <Redirect from="/ops-support" to="/ops-support/start" />
  </Switch>
);

const OpsSupport = () => {
  const { user } = useUserAuth();
  return <> {user && switchRoutes} </>;
};

export default OpsSupport;
